import { render, staticRenderFns } from "./ffc_testimonial.vue?vue&type=template&id=77cbe00d"
import script from "./ffc_testimonial.vue?vue&type=script&lang=js"
export * from "./ffc_testimonial.vue?vue&type=script&lang=js"
import style0 from "./ffc_testimonial.vue?vue&type=style&index=0&id=77cbe00d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports